import { Component, OnInit } from '@angular/core';
import { tabs } from '../../data/static/SelfEnrolTabs';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-verification-valid',
  templateUrl: './verification-valid.component.html',
  styleUrls: ['./verification-valid.component.css']
})
export class VerificationValidComponent implements OnInit {
  tabs = [];

  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit() {
    this.tabs = tabs;
  }

  done() {
    this.authService.logout();
    this.router.navigate(['login']);
  }

}
